<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    destroy-on-close
    :close-on-click-modal="false"
    width="800px"
    @close="closeDoalog"
  >
    <p>正在签章，请完成签章操作后，点击“完成签章”或者直接选择“退出签章”</p>
    <div slot="footer">
      <el-button @click="closeDoalog">
        退出签章
      </el-button>
      <el-button type="primary" @click="closeDoalog">
        完成签章
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  data () {
    return {
      isShow: false
    };
  },

  methods: {
    openDialog () {
      this.isShow = true;
    },

    closeDoalog () {
      this.isShow = false;
      this.$emit('close-back');
    }
  }
};
</script>
